import { Mapper } from "../../common/api/Mapper";
import { UserDto } from "./UserDto";
import { User } from "./UserModel";

/**
 * {@link UserDto} から {@link User} へ変換するマッパーです。
 */
class UserMapper implements Mapper<UserDto | undefined, User> {
  map(src: UserDto | undefined): User {
    if (!src) {
      return {
        id: -1,
        userId: "",
        familyName: "",
        givenName: "",
        role: 11,
        superUser: false,
      };
    }

    return {
      id: src.id,
      userId: src.userId,
      familyName: src.familyName,
      givenName: src.givenName,
      role: src.role,
      superUser: src.superUser,
    };
  }

  mapList(): User[] {
    return [];
  }
}

/**
 * ユーザ用のmapperです。
 */
export const userMapper = new UserMapper();
